/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import styled               from 'styled-components';
import { Colours, Borders } from '../../../styles/variables';
import { rgba }             from 'polished'
import { Media }            from '../../../styles/utilities';


/*********************************************************************************
 2. Component
 *********************************************************************************/

export const StyledFeaturePicture = styled.picture`
  img {
    max-width: 100%;
    display: block;
    margin: 0 auto 20px;
    border-radius: ${Borders.Radius};
    box-shadow: 0 0 13px 0 ${rgba(Colours.Alto, 0.5)};
  }
  ${Media.Tablet`
    img {
      margin-bottom: 0;
    }
  `}
`;



// WEBPACK FOOTER //
// ./src/components/atoms/StyledFeaturePicture/index.js